import { PropsWithChildren, useMemo } from 'react'
import { SWRConfig } from 'swr'

import { useAuthStore } from '@/store/auth'
import { redirectToLoginOnSessionExpired } from '@/utils/session-error'

import { createFetcher } from '@/lib/swr/fetcher'

function SWRProvider({ children }: PropsWithChildren) {
  const clearAuth = useAuthStore((state) => state.clearAuth)
  const fetcher = useMemo(
    () =>
      createFetcher({}, () => {
        clearAuth()
        redirectToLoginOnSessionExpired()
      }),
    [clearAuth]
  )

  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        dedupingInterval: 2000
      }}
    >
      {children}
    </SWRConfig>
  )
}

export default SWRProvider
